import { IconButton, Modal,ContextualMenu,mergeStyleSets, PrimaryButton, DefaultButton, Spinner, SpinnerSize } from "@fluentui/react";
import React, { useEffect, useState,useContext,useRef } from "react";
import $ from "jquery";
import "./modalStyle.css";
import { generateRSNADynamicReport, getHTMLTemplate } from "../../../../../service/StudyReportService";
import studyviewerContext from "../../../../../context/studyviewer/StudyviewerContext";
import studyReportContext from "../../../../../context/studyreport/StudyReportContext";
import { circlStyle, covidReportState } from "../../../helper/initialData";
import { generateCovidReport } from "../../../helper/HRCTUtilities";
import { CUSTOM_STYLES, REPORT_TITLE } from "../../../../../constants/Constants";
import themeContext from "../../../../../context/theme/ThemeContext";
import { iconButtonStyles, iconButtonStylesFunc } from "../../../../../components/Modal/ModalHeader";

const HrctChestILDModal = (props) => {

  const [htmlContent,setHTMLContent] = useState();
  const [loading,setLoading] = useState(false);
  const containerRef = useRef(null);
  const {setModel,currentActiveTab} = useContext(studyReportContext);
  const { getThemeColor } = useContext(themeContext);

  const getHTMLTemplateCall = async(id)=>{
    setLoading(true);
    let res = await getHTMLTemplate(id);
    console.log("Resposne HTML ");
    console.log(res);
    if(res.status == 200){
      if(res.data.result == "SUCCESS"){
        let content = res.data.data.report;
        setHTMLContent(content);
        setLoading(false);
      }else{
        setLoading(false);
      }
    }
  }

  useEffect(()=>{
    console.log("IDD "+props.id);
      if(props.id != null && props.id != undefined){
          getHTMLTemplateCall(props.id);
      }
  },[props.id])

  const {
    setReportModalState,
    reportModalState,
    regenerateHRCT
} = useContext(studyReportContext);

   // const [isModalOpen,setIsModalOpen] = useState(false);

    const contentStyles =  mergeStyleSets({
      root:{
        backgroundColor: 'rgba(0, 0, 0, 0.75);',
      },
        container: {
          display: 'flex',
          width:'900px',
          height:'700px',
          overflowY:'hidden',
          overflowX:'hidden',
          borderRadius:'10px',
          boxShadow: "0px 4px 20px 0px rgba(0, 0, 0, 0.90)",
          border: CUSTOM_STYLES.MODAL_BORDER,
          background: getThemeColor("modal-body")
        },
        scrollableContent:{
            overflowY:'hidden'
        },
        header: [
          {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            padding: '10px',
            background:getThemeColor("modal-header-footer"),
            cursor: "pointer"
          },
        ],
        footer:[
            {
                display: 'flex',
                justifyContent:"space-between",
                background:getThemeColor("modal-header-footer"),
                padding: '10px'
            }
        ]
      });
    
    const cancelIcon = { iconName: 'Cancel' }; 

    const regenerateHRCTReport = () => {
        let response = generateCovidReport(props.content.text);
      // console.log(response);
      let tempContent = props;
      tempContent.content.reportDetails.report = response;
      setReportModalState(() => {
          const newVal = { ...reportModalState };
          newVal.hrctChestILD = false;
          newVal.content = tempContent;
          return newVal;
        });
        
      props.hideModal();
      regenerateHRCT(tempContent);
    }

    useEffect(() => {
      if (containerRef.current) {
        const elements = containerRef.current.querySelectorAll('.hrct-body select, .hrct-body textarea, .hrct-body input');
        if (elements.length > 0) {
          elements.forEach(element => {
            element.style.backgroundColor = getThemeColor("modal-body");
            element.style.color = getThemeColor("primary-color");
          });
        }
      }
    }, [htmlContent]);

    return (
        <Modal
        isOpen={props.isModalOpen}
        containerClassName={contentStyles.container}
        dragOptions= {{
            moveMenuItemText: "Move",
            closeMenuItemText: "Close",
            menu: ContextualMenu,
            dragHandleSelector: "#header-id",
            keepInBounds: true,
      }}
        styles={contentStyles}
      >
         {loading &&  <Spinner size={SpinnerSize.large} styles={circlStyle}/>}
        {!loading && <>
        <div id="header-id" className={contentStyles.header}>
          <div id="rsna-title" style={{color: getThemeColor("primary-color")}} className="modal-header-heading-updated">
            {props.content.text}
          </div>
          <IconButton
            styles={iconButtonStylesFunc(getThemeColor)}
            iconProps={cancelIcon}
            ariaLabel="Close popup modal"
            onClick={props.hideModal}
          />
        </div>
        <div ref={containerRef} style={{color: getThemeColor("primary-color")}} id={REPORT_TITLE.HRCT_CHEST_COVID==props.content.text?
        "covidPopupContext":"hrctPopupContext"} className="hrct-body modal-scroll-rsna" 
        dangerouslySetInnerHTML={{__html: htmlContent}}
        >
        </div>
        <div className={contentStyles.footer}>
            <div style={{display:'flex'}}>
                <DefaultButton text="Cancel" onClick={props.hideModal} />
                <PrimaryButton style={{marginLeft:'10px'}} text="Reset" />
            </div>
           
            <PrimaryButton text="Regenerate" onClick={()=>{
              
              regenerateHRCTReport();
              }} />
        </div></>}
      </Modal>
    )
}

export default HrctChestILDModal;